import type { RouterOutput } from '../../../server/types/infer-trpc-types.ts';
import { api } from '../../../utils/api.ts';

export type OrderAttachment =
    RouterOutput['platoUser']['grid']['getDetailQuoteOrder']['getSalesDocuments'][number];

export const useOrderAttachments = ({ transactionId }: { transactionId: string }) => {
    return api.platoUser.grid.getDetailQuoteOrder.getSalesDocuments.useQuery(
        {
            id: transactionId,
        },
        {
            refetchOnMount: false,
        },
    );
};
